<style>
.bg-primary {
  background-color: #1a3665 !important;
}
</style>
<template>
  <CCard>
    <div class="card-header bg-primary font-weight-bold text-white" style="display: flex; align-items: center;">
      Data Anggota
      <Button
        class="btn btn-md btn-dark px-4 py-2 ml-auto text-white"
        @click="$router.push('/keanggotaan/data-anggota/unverified')"
      >Kembali</Button>
    </div>
    <ul 
      class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
      <li class="nav-item border-0">
        <router-link
          :to="'/keanggotaan/data-anggota/data-diri/'+this.$route.params.id_user"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          style="background-color: #486ba7;"
          id="home-tab"
          data-toggle="tab"
          href="#home"
          role="tab"
          aria-controls="home"
          aria-selected="true">Data Anggota</router-link>
      </li>
      <li class="nav-item border-0">
        <router-link
          :to="'/keanggotaan/data-anggota/data-sertifikasi/'+this.$route.params.id_user"

          style="background-color: #214073 !important;"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"          
          id="home-tab"
          data-toggle="tab"
          href="#home"
          role="tab"
          aria-controls="home"
          aria-selected="true"
        >
          Data Sertifikasi
        </router-link>
      </li>
      <li class="nav-item border-0">
        <router-link
          :to="'/keanggotaan/data-anggota/data-rpl/'+this.$route.params.id_user"

          style="background-color: #214073 !important;"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="profile-tab"
          data-toggle="tab"
          href="#profile"
          role="tab"
          aria-controls="profile"
          aria-selected="false"
        >
          Data RPL
        </router-link>
      </li>
      <li class="nav-item border-0">
        <router-link
          :to="'/keanggotaan/data-anggota/data-pelatihan/'+this.$route.params.id_user"
          style="background-color: #214073 !important;"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="contact-tab"
          data-toggle="tab"
          href="#contact"
          role="tab"
          aria-controls="contact"
          aria-selected="false" 
        >
          Data Pelatihan
        </router-link>
      </li>
      <li class="nav-item border-0">
        <router-link
          :to="
            '/keanggotaan/data-anggota/data-sanksi/' +
            this.$route.params.id_user
          "
          style="background-color: #214073 !important"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="contact-tab"
          data-toggle="tab"
          href="#contact"
          role="tab"
          aria-controls="contact"
          aria-selected="false"
        >
          Sanksi
        </router-link>
      </li>
    </ul>
    <CCardBody>
      <CRow>
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-3 mt-3 px-0">
          <!-- Tabs -->
          <div class="card border-0">
            <h5 class="card-header text-bold">Profile Settings</h5>
            <ul class="list-group list-group-flush">
              <li class="list-group-item">
                <router-link
                  :to="'/keanggotaan/data-anggota/data-diri/'+this.$route.params.id_user"
                  class="nav-link text-dark"
                >Data Diri</router-link>
              </li>
              <li class="list-group-item">
                <router-link
                  :to="'/keanggotaan/data-anggota/data-anggota/'+this.$route.params.id_user"
                  class="nav-link text-dark"
                >Data Anggota</router-link>
              </li>
              <li class="list-group-item">
                <router-link
                  :to="'/keanggotaan/data-anggota/data-dokumen/'+this.$route.params.id_user"
                  class="nav-link text-dark"
                  style="color:#2F3AAA;font-weight:bold"
                >Data Dokumen Pendukung</router-link>
              </li>
              <li class="list-group-item">
                <router-link
                  :to="'/keanggotaan/data-anggota/sanksi/'+this.$route.params.id_user"
                  class="nav-link text-dark"
                >Data Sanksi</router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9 mt-3">
          <!-- small box -->
          <div class="card border-0">
            <h5 class="card-header text-bold">Data Dokumen Pendukung</h5>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Nama File</th>
                      <th>Status Dokumen</th>
                      <th>Status</th>
                      <th class="text-center" colspan="2">Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(value , index) in dokumenPeserta" v-bind:key="index">
                      <td>{{ index+1 }}</td>
                      <td
                        class="w-50 w-sm-100 text-uppercase"
                        style="text-align:left"
                      >{{ value.namaDokumen }}</td>
                      <td class="w-50 w-sm-100 text-uppercase pl-4 font-weight-bold text-primary" v-if="value.statusKewajiban == 1">Wajib</td>                        
                      <td class="w-50 w-sm-100 text-uppercase pl-4 font-weight-bold text-danger" v-else>Tidak Wajib</td>                        
                      <td
                        class="font-weight-bold text-secondary"
                        v-if="value.statusUpload == '0'"
                      >Belum Upload</td>
                      <td
                        class="font-weight-bold text-success"
                        v-if="value.statusUpload ==   '1'"
                      >Terverifikasi</td>
                      <td
                        class="font-weight-bold text-primary"
                        v-if="value.statusUpload ==   '2'"
                      >Sudah Upload</td>
                      <td
                        class="font-weight-bold text-info"
                        v-if="value.statusUpload ==      '3'"
                      >File Tidak Terbaca</td>
                      <td
                        class="font-weight-bold text-danger"
                        v-if="value.statusUpload ==    '4'"
                      >File Tidak Sesuai</td>
                      <td class="text-center">
                        <button
                          v-c-tooltip="'Lihat Dokumen'"
                          class="btn btn-success text-light p-0 px-3 shadow mx-auto"
                          :disabled="value.statusUpload == '0' "
                          @click="bukaFile(value.file)">
                          <small><i class="fa fa-eye"  ></i></small>
                        </button>
                      </td>
                      <td class="text-center">
                        <button
                          v-c-tooltip="'Verifikasi'"
                          class="btn btn-info text-light p-0 px-3 shadow mx-auto"
                          :disabled="value.statusUpload == '0'"
                          @click="verifikasiDokumen(value.idDokumenPendukungPeserta,value.statusUpload,value.alasan)"
                        >
                          <small><i class="fa fa-check"  ></i></small>
                        </button>
                      </td>
                      
                      
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </CRow>
      <!-- Modal Verifikasi -->
      <CModal
        title="Modal title"
        :show.sync="modalVerif"
        :no-close-on-backdrop="true"
        :centered="true"        
      >
        <CForm>
          <CRow>
            <CCol sm="12">
              <label for class="font-weight-bold">Diverifikasi Pada</label>
              <br />
              <CInput class="font-weight-bold" type="date" v-model="formData.verifikasiPada" />
            </CCol>

            <CCol sm="12 mb-4">
              <label for class="font-weight-bold">Status</label>
              <br />
              <select name="id_outlet" v-model="formData.statusUpload" class="form-control mb-2">
                <option value="1" :selected="formData.statusUpload == '1'">Terverifikasi</option>
                <option value="3" :selected="formData.statusUpload == '3'">File Tidak Terbaca</option>
                <option value="4" :selected="formData.statusUpload == '4'">File Tidak Sesuai</option>
              </select>
            </CCol>
            <CCol sm="12" v-if="formData.statusUpload != '1'">
              <label for class="font-weight-bold">Alasan <span>(Opsional)</span></label>
              <textarea class="form-control" name="" id="" cols="30" rows="4" v-model="formData.alasan" placeholder="Masukkan alasan"></textarea>
            </CCol>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Verifikasi Data Dokumen Pendukung</h6>
        </template>
        <template #footer>
          <CButton @click="modalVerif = false" color="danger">Tutup</CButton>
          <CButton type="submit" @click="postData" color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
      <CModal
        title="Modal title"
        :show.sync="modalEmail"
        :no-close-on-backdrop="true"
        :centered="true"        
      >
        <CForm>
          <CRow>
            <CCol sm="12">
              <CInput class="font-weight-bold" label="Subjek" placeholder="Masukkan Subjek" />
            </CCol>
            <CCol sm="12">
              <CTextarea
                class="font-weight-bold"
                label="Pesan"
                rows="3"
                placeholder="Masukkan isi pesan"
              />
            </CCol>

            <CCol sm="12 mb-5">
              <label for="uid-zwqayuopq3" class="font-weight-bold">File (Opsional)</label>
              <br />
              <div class="custom-file text-truncate">
                <input type="file" class="custom-file-input" id="validatedCustomFile" />
                <label class="custom-file-label text-truncate" for="validatedCustomFile">{{ fileName }}.</label>
                <label class="custom-file-label text-truncate" for="validatedCustomFile">Choose file</label>
              </div>
            </CCol>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Kirim Email</h6>
          <CButtonClose @click="modalEmail = false" class="text-white" />
        </template>
        <template #footer class="mt-5">
          <CButton @click="modalEmail = false" color="danger">Tutup</CButton>
          <CButton type="submit" color="success">Kirim</CButton>
        </template>
      </CModal>
    </CCardBody>
  </CCard>
</template>
<script>
import DataKeanggotaanService from "../../../../../services/keanggotaan/data-anggota.service";
import Utils from "../../../../../services/utils.service";

export default {
  name: "DataDokumen",
  el: "#app",
  data() {
    return {
      fileName: "Choose File",
      details: {},
      masterDokumen: [],
      dokumenPeserta: [],
      formData: {
        idDokumenPendukungPeserta: "",
        statusUpload: "",
        alasan: "",
        verifikasiPada: new Date().toISOString().slice(0, 10)
      },
      no: 1,
      status: false,
      modalVerif: false,
      modalEmail: false,
      horizontal: { label: "col-3", input: "col-9" },

      collapseDuration: 0,
      index: 0,
      content: []
    };
  },
  mounted() {
    this.getData();
    this.formData.idUser = this.$route.params.id_user;
  },
  methods: {
    alertError() {
      this.$swal.fire({
        title: "Peringatan!",
        text: "Data Gagal Disimpan",
        icon: "errorr",
        showCancelButton: true
      });
    },
    bukaFile(file) {
      
      let user = JSON.parse(localStorage.getItem('user'));
      let token = user.accessToken
      let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
width=0,height=0,left=-1000,top=-1000`;
      window.open(
        Utils.baseurlFoUsers() + "/lihat-file/"+file+"/lokasi/data_dokumen_pendukung/bearer/" + token,
        file,
        params
      );
    },
    updateDataAnggota() {
      DataKeanggotaanService.updateDataAnggota(
        this.$route.params.id_user,
        this.details
      )
        .then(response => {
          // comment console console.log(response);
          this.alertSuccess();
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },
    alertSuccess() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Disimpan"
      });
    },
    alertVerif(message) {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: message
      });
    },
    verifikasiDokumen(idDokumenPendukungPeserta, statusUpload, alasan) {
      this.modalVerif = true;
      this.formData.idDokumenPendukungPeserta = idDokumenPendukungPeserta;
      this.formData.statusUpload = statusUpload;
      this.formData.alasan = alasan;
      
    },

    getData() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      DataKeanggotaanService.getDokumenPendukungPeserta(
        this.$route.params.id_user
      )
        .then(response => {
          this.dokumenPeserta = response.data.singleData.dataDokumen;
          this.statusVerif = response.data.singleData.status_verif;
          // comment console console.log(response);
          loader.hide();
        })
        .catch(error => {
          // comment console console.log(error);
          loader.hide();

        });

      // comment console console.log("data data data");
      // comment console console.log("sdf" + this.masterDokumen);

      // var arr1 = this.content[0];
      // var arr2 = this.content[1];
      // // comment console console.log("array baru"+arr1)
    },

    postData() {
      var vm = this;
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      DataKeanggotaanService.verifikasiDataDokumen(this.formData)
        .then(response => {
          // comment console console.log(response);
          loader.hide();
          
          this.modalVerif = false;
          
          if (this.formData.statusUpload == '1') {
            this.alertVerif("Status Berhasil Verifikasi ")
          } else  {
            this.alertVerif("Status Berhasil Diubah");
          } 
          vm.getData();
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error);
        });
    }
  }
};
</script>
